import { React, useState, useEffect, useRef } from "react";
import cardRoad from "../../cardData/cardImageRoad";
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function CardRoad() {
  const [cardRoadArray, setCardRoadArray] = useState([]);
  const swiperRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  useEffect(() => {
    const randomArrayCard = cardRoad.sort(() => Math.random() - 0.5);
    setCardRoadArray(randomArrayCard);
  }, []);

  useEffect(() => {
    // Инициализируем Swiper только когда данные загружены и компонент отрендерен
    if (
      cardRoadArray.length > 0 &&
      swiperRef.current &&
      !swiperInstanceRef.current
    ) {
      swiperInstanceRef.current = new Swiper(swiperRef.current, {
        slidesPerView: "auto",
        speed: 2000,
        loop: true,
        spaceBetween: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 0, // 3 секунды между переключениями
          disableOnInteraction: false, // продолжать автопрокрутку после ручного переключения
          pauseOnMouseEnter: true, // пауза при наведении мыши на слайдер
          stopOnLastSlide: false,
        },
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        centeredSlides: false,
      });
    }

    // Cleanup при размонтировании
    return () => {
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy(true, true);
        swiperInstanceRef.current = null;
      }
    };
  }, [cardRoadArray]); // Зависимость от cardRoadArray

  return (
    <div className="swiper swiperRoad" ref={swiperRef}>
      <div className="swiper-wrapper">
        {cardRoadArray.map((card) => (
          <div key={card.id} className="swiper-slide-road swiper-slide">
            <img
              className="swiperCardRoad"
              src={card.url}
              alt="изображение карточки товара"
            />
          </div>
        ))}
      </div>
      <div className="swiper-button-prev"></div>
      <div className="swiper-button-next"></div>
    </div>
  );
}

export default CardRoad;
